export const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export function shiftDays(isoDate, delta) {
  const d = new Date(`${isoDate}T00:00:00`);
  d.setDate(d.getDate() + delta);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function hours(v) {
  if (v == null) return "—";
  if (v >= 24) return `${(v / 24).toFixed(2)} day`;
  if (v >= 1) return `${v.toFixed(2)} hr`;
  return `${Math.round(v * 60)} min`;
}
